var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['common-iconfont', 'common-iconfont-' + _vm.type],style:({ fontSize: _vm.size + 'px', color: _vm.color })})}
var staticRenderFns = []

export { render, staticRenderFns }